<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [showRefreshBtn]="false"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>
          <div *ngIf="!documentLoading" class="row tw-mt-20">
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3"
              *ngFor="let item of documentationTypes; let i = index"
            >
              <app-show-documents
                [documentTypes]="documentationTypes"
                [currentId]="currentOrganizationId"
                [selectedId]="selectedOrganizationId"
                [blob]="getBlob(model[i]?.organizationDocument)"
                [modelItems]="model"
                [counter]="i"
                (changeStatus)="changeStatus($event)"
              >
              </app-show-documents>
            </div>
          </div>

          <div class="row" *ngIf="documentLoading">
            <div class="tw-flex-center role-organizations-loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span class="text-primary tw-text-lg tw-font-medium tw-mx-2">{{
                "common.loading" | translate
              }}</span>
            </div>
          </div>

          <!--isAuthenticated-->
          <div
            class="row"
            *ngIf="currentOrganizationId != selectedOrganizationId"
          >
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-flex">
              <div class="checkbox-section">
                <mat-slide-toggle
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="authenticateModel.isAuthenticated"
                >
                  {{
                    pageVocabs + "fields.isAuthenticated" | translate
                  }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>
        </fieldset>
      </section>
      <!-- form btns-->
      <app-form-btns
        *ngIf="currentOrganizationId != selectedOrganizationId"
        [loading]="loading"
        [form]="form"
        (onClose)="onClose()"
        (onSubmit)="baseUpdateApi()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
<div id="fullpage" onclick="this.style.display='none';"></div>
